import script from "./OrdersView.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrdersView.vue?vue&type=script&lang=ts&setup=true"

import "./OrdersView.vue?vue&type=style&index=0&id=ea183cf2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea183cf2"]])

export default __exports__